// extracted by mini-css-extract-plugin
module.exports = {"anonymousHeader":"AnonymousLayout_anonymousHeader__3Od1h","content":"AnonymousLayout_content__2vq0g","anonymousLayout":"AnonymousLayout_anonymousLayout__3WEZp"};